import { supabase } from "../config/supabaseClient";

// Helper to create slugs from topic strings
export const createSlug = (str) => {
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/--+/g, "-")
    .trim();
};

// Extract plain text from HTML string
export const extractTextFromHTML = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

// Fetch products by topicSlug
export const fetchProducts = async (topicSlug) => {
  try {
    const { data, error } = await supabase
      .from('topics')
      .select('*');

    if (error) throw error;

    const productList = data
      .map((doc) => ({
        id: doc.id,
        ...doc,
        slug: createSlug(doc.topic),
      }))
      .filter(
        (product) =>
          product.id === topicSlug || product.slug === topicSlug
      );
    return productList;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

// Fetch all topics filtered by subCategory/class and sorted by timestamp
export const fetchAllTopics = async (subCategory) => {
  try {
    let query = supabase.from('topics').select('*');
    if (subCategory && (subCategory.toLowerCase() === 'applied grammar' || subCategory.toLowerCase() === 'grammar')) {
      query = query.or('subCategory.eq."Applied Grammar",class.eq."Applied Grammar",subCategory.eq."Grammar",class.eq."Grammar"');
    } else {
      query = query.or(`subCategory.eq."${subCategory}",class.eq."${subCategory}"`);
    }
    const { data, error } = await query.order('timestamp', { ascending: true });

    if (error) throw error;

    const topicsList = data.map((doc) => ({
      id: doc.id,
      ...doc,
      slug: createSlug(doc.topic),
    }));

    return topicsList;
  } catch (error) {
    console.error("Error fetching all topics:", error);
    return [];
  }
};

// Calculate number of correct answers
export const calculateResults = (mcqs, selectedAnswer) => {
  let correctAnswers = 0;
  mcqs.forEach((mcq, index) => {
    if (selectedAnswer[index] === mcq.correctAnswer) {
      correctAnswers++;
    }
  });
  return correctAnswers;
};

// Get next topic from the list
export const getNextTopic = (allTopics, currentTopicIndex) => {
  if (currentTopicIndex === null || currentTopicIndex + 1 >= allTopics.length)
    return null;
  return allTopics[currentTopicIndex + 1];
};

// Get previous topic from the list
export const getPrevTopic = (allTopics, currentTopicIndex) => {
  if (currentTopicIndex === null || currentTopicIndex - 1 < 0) return null;
  return allTopics[currentTopicIndex - 1];
};


